import React, { useState, useEffect, useRef } from 'react';
import ScreenshotPicker from './ScreenshotPicker';

const ScreenshotContainer = (props) => {
    const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
    // const [refPos, setRefPos] = useState({ x: 0, y: 0 });
    const [needMousePos, setNeedMousePos] = useState(false);
    // const [containerExtending, setContainerExtending] = useState(false);
    // const [containerDragging, setContainerDragging] = useState(false);
    const [bodySize, setBodySize] = useState(null);
    const containerRef = useRef(null);

    useEffect(() => {
        getBodySize();
    }, []);

    const onContainerExtending = (msg) => {
        if (msg.containerExtending) {
            // setContainerExtending(msg.containerExtending);
            setNeedMousePos(true);
        }
    };

    const onContainerDragging = (msg) => {
        if (msg.containerDragging) {
            // setContainerDragging(msg.containerDragging);
            setNeedMousePos(true);
        } else {
            // setContainerDragging(false);
            setNeedMousePos(false);
            setMousePos({ x: 0, y: 0 });
        }
    };

    const onMouseMove = (e) => {
        if (needMousePos) {
            setMousePos({ x: e.clientX, y: e.clientY });
        }
    };

    const getBodySize = () => {
        const size = {
            width: containerRef.current.clientWidth,
            height: containerRef.current.clientHeight,
        };
        setBodySize(size);
        return size;
    };

    const closeScreenshotPicker = () => {
        props.closeScreenshotPicker();
    };

    const getSreenshotArea = (msg) => {
        props.getSreenshotArea(msg);
    };

    const containerStyle = {
        position: "fixed",
        top: "0px",
        left: "0px",
        width: "100%",
        height: "100%",
        zIndex: "5000",
    };

    return (
        <div style={containerStyle} ref={containerRef} onMouseMove={onMouseMove}>
            {bodySize ? (
                <ScreenshotPicker
                    bodySize={bodySize}
                    mousePos={mousePos}
                    containerExtending={onContainerExtending}
                    containerDragging={onContainerDragging}
                    closeScreenshotPicker={closeScreenshotPicker}
                    getSreenshotArea={getSreenshotArea}
                    fullScreenMode={props.fullScreenMode}
                />
            ) : null}
        </div>
    );
};

export default ScreenshotContainer;
